import * as maptalks from "maptalks"
import {mapConfig, initConfigData} from "../gisConfig.js"

export var _g_map, _g_vectorLayer;

export default class MapManager {
  constructor() {
    this.initialize();
  }

  initialize() {

  }

  createMap(domId, options) {
    initConfigData()
    if (options) {
      Object.assign(mapConfig, options);
    }

    let _mapOpts = {};
    _mapOpts = {
      center: mapConfig.center,
      minZoom: mapConfig.minZoom,
      maxZoom: mapConfig.maxZoom,
      zoom: mapConfig.zoom
    };

    let baseLayerOpts = mapConfig.baseLayerOptsTD
    let layerOpts = mapConfig.layerOptsTD
    if (mapConfig.gisType === "bd") {
      baseLayerOpts = mapConfig.baseLayerOptsBD
      layerOpts = mapConfig.layerOptsBD

      _mapOpts.spatialReference = {projection: "baidu"};
    }
    if(options && options.cssFilter){
      baseLayerOpts.cssFilter = options.cssFilter
    }

    _mapOpts.baseLayer = new maptalks.TileLayer('base', baseLayerOpts);

    if (layerOpts.length > 0) {
      _mapOpts.layers = [];
      for (let i = 0, iMax = layerOpts.length; i < iMax; ++i) {
        if(options && options.cssFilter){
          layerOpts[i].cssFilter = options.cssFilter
        }
        _mapOpts.layers.push(new maptalks.TileLayer('layer_' + i, layerOpts[i]));
      }
    }

    _mapOpts.scaleControl = mapConfig.scaleControl;

    _g_map = new maptalks.Map(domId, _mapOpts)

    _g_vectorLayer = new maptalks.VectorLayer("_vectorLayer_inner").addTo(_g_map)

    return _g_map
  }

  getMap() {
    return _g_map
  }

  getVectorLayer() {
    return _g_vectorLayer
  }
}



// WEBPACK FOOTER //
// ./src/components/EXGis/module/MapManager.js